import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { evaluatePublicRpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsPublicEvaluationService';
import { getChirpEarlyRequest } from '../utils/earlyRequest';
import { transformToLegacyPurchaseMotionsShape } from './transformToLegacyPurchaseMotionsShape';
const noAuthChirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const getPublicAppLegacyPurchaseMotionsResponse = requestedLocations => {
  var _COUNTRY_CODE_FROM_LO;
  const request = {
    locations: requestedLocations,
    productApiNames: [],
    requestedCountryCode: ((_COUNTRY_CODE_FROM_LO = window.COUNTRY_CODE_FROM_LOCALE) === null || _COUNTRY_CODE_FROM_LO === void 0 ? void 0 : _COUNTRY_CODE_FROM_LO.toUpperCase()) || ''
  };
  return getChirpEarlyRequest({
    details: Object.assign({}, evaluatePublicRpc, {
      earlyRequest: true
    }),
    requestObject: {
      request
    },
    fallbackFetcher: () => noAuthChirpClient.call(evaluatePublicRpc, {
      request
    })
  }).then(purchaseMotionsResponse => {
    return {
      locations: transformToLegacyPurchaseMotionsShape(requestedLocations, purchaseMotionsResponse)
    };
  });
};